<template>
    <div class="h-full relative p-6 lg:p-12">
        <!--<div
            class="absolute inset-0 bg-gray-200/80 z-10"
            v-if="!step6Complete"
        ></div>-->
        <div
            class="absolute inset-0 z-20 bg-gray-500/90 transition-opacity"
            v-if="!step6Complete"
        ></div>
        <div class="absolute inset-0 z-20" v-if="!step6Complete">
            <div class="absolute inset-0 z-20 w-100 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
                >
                    <div
                        class="relative transform overflow-hidden rounded-lg bg-white dark:bg-slate-800 px-4 pb-4 pt-5 text-left shadow-xl dark:shadow-slate-900/50 transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
                    >
                        <div>
                            <div
                                class="mx-auto flex items-center justify-center"
                            >
                                <span class="fa-stack relative z-20 fa-lg">
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-red-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                                    ></i>
                                </span>
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3
                                    class="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100"
                                    id="modal-title"
                                >
                                    Go Back to the Previous Step
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500 dark:text-gray-400">
                                        You must complete the previous step
                                        before continuing.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!stepComplete">
            <div class="rounded-lg bg-white dark:bg-slate-800 p-6 shadow-lg dark:shadow-slate-900/50 mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Spend Away
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-orange-100"
                        ></i>
                        <i
                            class="fa-regular fa-timer fa-stack-1x fa-inverse text-orange-700"
                        ></i>
                    </span>
                </h3>
                <p class="mb-3">
                    You're free and clear to spend away on both of your new
                    Southwest Credit Cards now.
                </p>
            </div>
            <img
                src="/images/companionpass/companionpass_spendaway.png"
                class="mx-auto mb-5 lg:mb-10"
                alt="My10X"
            />
        </div>
        <div v-if="stepComplete">
            <div class="rounded-lg bg-white dark:bg-slate-800 p-6 shadow-lg dark:shadow-slate-900/50 mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Step 7 Complete
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-green-100"
                        ></i>
                        <i
                            class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                        ></i>
                    </span>
                </h3>
                <p class="text-base mb-3">
                    You've taken the final step in earning your Companion Pass
                    by meeting both of the minimum spends on your new Southwest
                    Credit Cards! 🎉🎉
                </p>
            </div>
            <OpenCard :card="step?.cards[0]" :account="step?.accounts[0]" />
            <OpenCard :card="step?.cards[1]" :account="step?.accounts[1]" />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

import OpenCard from '@/components/companion-pass/cards/open-card.vue';

export default {
    name: 'StepSeven',
    props: {},
    components: {
        OpenCard,
    },
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, ['completeSteps']),
        cdnUrl() {
            return window.cdnUrl;
        },
        stepContent() {
            return this.getStepContent(6);
        },
        step() {
            return this.getStep(6);
        },
        step1() {
            return this.getStep(1);
        },
        step5() {
            return this.getStep(5);
        },
        stepComplete() {
            return 7 in this.completeSteps ? true : false;
        },
        step6Complete() {
            return 6 in this.completeSteps ? true : false;
        },
        daysLeft() {
            return this.step1?.days_left;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, ['getStep', 'getStepContent']),
    },
    mounted() {},
};
</script>
